import _extends from "@babel/runtime/helpers/extends";
import React, { useEffect, useImperativeHandle } from 'react';
import classNames from 'classnames';
import SignaturePad from 'signature_pad';
import styles from './signature.scss';
export const SignatureDrawer = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    className,
    options,
    onSign,
    ...rest
  } = props;
  const pad = React.useRef();
  const $input = React.useRef(null);
  const $canvas = React.useRef(null);
  const [text, setText] = React.useState();
  useImperativeHandle(ref, () => ({
    toDataURL() {
      return pad.current.toDataURL();
    },
    isEmpty() {
      return pad.current.isEmpty();
    },
    clear() {
      setText('');
      pad.current.clear();
    }
  }), []);
  useEffect(() => {
    var _pad$current2;
    if (!text || !$canvas.current) {
      var _pad$current;
      (_pad$current = pad.current) == null || _pad$current.clear();
      return;
    }
    const ctx = $canvas.current.getContext('2d');
    const width = $canvas.current.offsetWidth;
    const height = $canvas.current.offsetHeight;
    ctx.font = '35px Sacramento';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillStyle = (options == null ? void 0 : options.penColor) || 'black';
    (_pad$current2 = pad.current) == null || _pad$current2.clear();
    ctx.fillText(text, width / 2, height / 2);
    onSign();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [text, options == null ? void 0 : options.penColor]); // omitted callbacks to avoid infinite loop

  useEffect(() => {
    if (!$canvas.current) {
      return;
    }
    initCanvas();
    pad.current = new SignaturePad($canvas.current, options);
    pad.current.addEventListener('endStroke', onSign);
    window.addEventListener('resize', initCanvas);
    return function () {
      var _pad$current3;
      window.removeEventListener('resize', initCanvas);
      (_pad$current3 = pad.current) == null || _pad$current3.removeEventListener('endStroke', onSign);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // omitted callbacks to avoid infinite loop

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("canvas", _extends({}, rest, {
    tabIndex: 0,
    ref: $canvas,
    onFocus: focusInput,
    onClick: focusInput,
    className: classNames(className, styles.canvas)
  })), /*#__PURE__*/React.createElement("input", {
    type: "text",
    tabIndex: -1,
    ref: $input,
    value: text,
    onChange: handleChange,
    className: styles.hiddenInput
  }));
  function handleChange(event) {
    setText(event.target.value);
  }
  function focusInput() {
    var _$input$current;
    (_$input$current = $input.current) == null || _$input$current.focus();
  }
  function initCanvas() {
    if (!$canvas.current) {
      return;
    }
    const ctx = $canvas.current.getContext('2d');
    const width = $canvas.current.offsetWidth;
    const height = $canvas.current.offsetHeight;
    const ratio = Math.max(window.devicePixelRatio || 1, 1);
    $canvas.current.width = width * ratio;
    $canvas.current.height = height * ratio;
    ctx == null || ctx.scale(ratio, ratio);
  }
});
//# sourceMappingURL=signature-drawer.js.map